<div class="content-inner loading" *ngIf="loading"></div>

<ng-template [ngIf]="!loading">      
    <div class="content-inner">
        <div class="workflow-section-heading" *ngIf="hasShiftBlocks()">
            {{unitOfServiceName}}
            <span class="link" *ngIf="hasTotalUosImports()">
                <button class="compact" (click)="editImported()"><span class="icon-pencil"></span> Edit</button>
              </span>
        </div>
        <div class="workflow-section-subheading" *ngIf="hasShiftBlocks()">Please enter total <span class="uosName">{{unitOfServiceName}}</span> for {{ getWorkflowDayString() }}</div>
        <form [formGroup]="enterUOSForm" *ngIf="!loadingRecords">           
            <div *ngFor="let block of shiftBlocks" class="shift-block workflow-input">
                <input type="number" min="{{minValue}} " max="{{maxValue}}" [formControlName]="getShiftBlockControlName(block.id)" id="{{getShiftBlockControlName(block.id)}}">
                <span *ngIf="hasTotalUosImportConfiguration(block)" [ngClass]="shiftBlockHasImportedData(block) ? 'has-imported-data' : 'no-imported-data'" (click)="openImportedValuesModal(block)"><span class="icon-download3"></span></span>
                <label *ngIf="ancillaryConfiguration.enterUOSByBlock" class="total" for="{{getShiftBlockControlName(block.id)}}">Total</label>
                <label *ngIf="enterByDay()" for="{{getShiftBlockControlName(block.id)}}">{{getShiftBlockLabel(block)}}</label>                
                <div *ngIf="valueOutOfRange(block.id)" class="validation-message warning">
                    Value must be a whole number between {{minValue}} and {{maxValue | number}}.
                </div>
            </div>
            <div *ngIf="enterByDay() && hasShiftBlocks()" class="shift-block workflow-input">
                <input type="number" id="total" [value]="totalUos" disabled>
                <label for="total" class="total">Total</label>
            </div>
            <div *ngIf="hasTotalUosImports()">
                <input class="check-box" id="reviewed" type="checkbox" value="checkbox" formControlName="reviewed">
                <label class="check-box" for="reviewed">Reviewed</label>
             </div>
        </form>
        <div *ngIf="!loadingRecords && !hasShiftBlocks() && ancillaryConfiguration.enterUOSByBlock" class="no-previous-block">This cost center has no previous shift block.  Please proceed to the next page.</div>
        <div *ngIf="!loadingRecords && !hasShiftBlocks() && !ancillaryConfiguration.enterUOSByBlock" class="no-previous-block">This cost center has no previous working day.  Please proceed to the next page.</div>
        <div class="loading" *ngIf="loadingRecords"></div>
    </div>
</ng-template>
